module.exports = __webpack_public_path__ + "static/img/Zheng_MA.cacc6a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Zheng_MA.png
// module id = 8iWC
// module chunks = 1